import React, { useState } from "react";
import Commontooltip from "../CommonTooltip/Commontooltip";
import { MomentDateTime, getValidData } from "../../Shared/Methods";
import classes from "./Table.module.css";

import deleteimg from "../../Assests/Images/delete.png";
import editimg from "../../Assests/Images/pencil.png";
import { Tablenodatafound } from "./TableNoDataFount";
import { useLocation, useNavigate } from "react-router-dom";

interface props {
  Data: any;
  pageSize: number;
  pageind: number;
  OBJKeys: string[];
  OBJHead: string[];
  setShowModal: any;
  setShowConfirmModal: any;
  selectedRow: any;
  setSelectedRow: any;
}

function MailSettingsTable({
  Data,
  pageSize,
  pageind,
  OBJKeys,
  OBJHead,
  setShowModal,
  setShowConfirmModal,
  selectedRow,
  setSelectedRow,
}: props) {
  const { items } = Data;

  const location = useLocation();
  const getAllIds = items?.map((ele: any) => ele?.mail_settings_id.toString());
  const { pathname } = location;
  const handleCheckAllIds = () => {
    return selectedRow?.length === getAllIds?.length;
  };
  console.log("selected", selectedRow, getAllIds, handleCheckAllIds());
  return (
    <>
      <tr>
        <td width="70px">
          <input
            type="checkbox"
            id="selectAll"
            checked={handleCheckAllIds()}
            onChange={() =>
              handleCheckAllIds()
                ? setSelectedRow([])
                : setSelectedRow(getAllIds)
            }
          />
        </td>
        {OBJHead?.map((ele, ind) => (
          <th key={ind}>{ele}</th>
        ))}
      </tr>

      {items?.length > 0 ? (
        items?.map((ele: any, ind: number) => (
          <tr key={ind}>
            <td>
              <input
                type="checkbox"
                id={ele?.mail_settings_id}
                checked={selectedRow.includes(ele?.mail_settings_id.toString())}
                onChange={(e) => {
                  if (selectedRow.includes(e?.target?.id)) {
                    const value = selectedRow.filter(
                      (val: any) => val !== e?.target?.id
                    );
                    setSelectedRow(value);
                  } else {
                    setSelectedRow([...selectedRow, e?.target?.id]);
                  }
                }}
              />
            </td>
            <td>{pageSize * pageind + (ind + 1)}</td>
            {OBJKeys?.map((val: any, index: any) => {
              return (
                <td key={index}>
                  {val === "created_at"
                    ? getValidData(ele[val] ? MomentDateTime(ele[val]) : "")
                    : getValidData(ele?.[val])}
                </td>
              );
            })}
            {pathname === "/device/viewdevice" ? null : (
              <td>
                <div
                  className={classes.action_container}
                  style={{
                    padding: 0,
                    background: "transparent",
                    justifyContent: "center",
                  }}
                >
                  {/* <Commontooltip
                    children={
                      <img
                        src={viewimg}
                        // onClick={() =>
                        //   SetdataViewModal({ isView: true, item: ele })
                        // }
                        onClick={() =>
                          navigate("/user/viewuser", {
                            state: {
                              item: ele,
                              userDevice: userDevice,
                              setUserDeviceDr: setUserDevice({
                                isView: "",
                                item: {},
                              }),
                            },
                          })
                        }
                        alt="viewimg"
                      />
                    }
                    msg="View"
                  /> */}
                  <Commontooltip
                    children={
                      <img
                        src={editimg}
                        onClick={() => {
                          setShowModal((pre: any) => {
                            return {
                              ...pre,
                              isView: true,
                              create: "Update",
                              item: ele,
                            };
                          });
                        }}
                        alt="editimg"
                      />
                    }
                    msg="Update"
                  />{" "}
                  <Commontooltip
                    children={
                      <img
                        src={deleteimg}
                        onClick={() =>
                          setShowConfirmModal({ isView: true, item: ele })
                        }
                        alt="deleteimg"
                      />
                    }
                    msg="Delete"
                  />
                </div>
              </td>
            )}
          </tr>
        ))
      ) : (
        <Tablenodatafound />
      )}
    </>
  );
}

export default MailSettingsTable;
